
export interface AddPreferenceModel{
    id:number
    brandId: number
    question: string
    questionDescription:string
    enquestionDescription: string
    dequestionDescription: string
    nlquestionDescription: string
    createdBy: string
    answerInputs: string
    imageBinaryData: string 
    mimeType: string
    image: string | ArrayBuffer
    preferenceImage: string | ArrayBuffer
    languageCode: string
}
export interface PreferenceModel{
    preferenceDetails: Preference,
    partDescription:PartDescriptionLanguageDetail[]
}

export interface PartDescriptionLanguageDetail{
    LanguageId:number,
    Description: string
}

export interface EditPreference{
     brandId: number
     question: string
     description: string
     updatedBy: string
     imageBinaryData: string 
     mimeType: string
     image: string | ArrayBuffer
     preferenceImage: string | ArrayBuffer
     answerInputs: string
}

export interface Preferences{
    id: number
    brandId: number
    question: string
    description: string
    preferenceImage: string
    createdBy: string
    createdDate: any
    updatedBy: string
    updatedDate: any,
    brand: string,
    isActive: boolean,
    answerInputs: string
}

export interface Preference{
    id: number
    brandId: number
    question: string
    description:string
    preferenceImage: string
    createdBy: string
    createdDate: Date
    updatedBy: string
    updatedDate: Date
    isActive: boolean,
    brand: string
    answerInputs: string
    imagePath:string
}

export class ActiveDealerDataMapper{
    dealerId: string
    dealerName: string
    isDealerActive: boolean
    isActiveDealerForPreference: boolean
}

export class GetAllActiveDealerResponseModel{
    dealerId: string;
    isActive: boolean;
}